export default "__VITE_ASSET__DKQQPv41__"